import React from "react";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { Checkbox } from "../../../../../components/Checkbox";
import { useLocation, useNavigate } from "react-router-dom";
import { StepperInglesLargo } from "../../../../../components/StepperInglesLargo";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

import "./style.css";

export const CorporativoBusinessBankingProductSelectionCodeWeb = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-document_id-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };
  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-select-producto">
            <div className="div-2">
              <div className="overlap-2">
                <div className="group-wrapper">
                  <div className="group-2">
                    <div className="overlap-3">
                      <div className="frame-2">
                        <div className="div-wrapper-sp">
                          <div className="group-3">
                            <div className="frame-wrapper">
                              <div className="frame-3">
                                <div className="text-wrapper-2">
                                  Product Selection
                                </div>

                                <p className="subtitle">
                                  Choose the product&nbsp;&nbsp;that best suits
                                  your company&#39;s needs.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="frame-4" />
                      </div>

                      <div className="card-violet-dark">
                        <div className="overlap-wrapper">
                          <div className="overlap-4">
                            <div className="card-violet-dark-2">
                              <div className="business-credit-card-wrapper">
                                <div className="business-credit-card">
                                  Business Credit
                                  <br />
                                  Card
                                </div>
                              </div>

                              <div className="text-wrapper-3">View details</div>

                              <div className="tarjetas-de-credito">
                                <div className="overlap-group-2">
                                  <img
                                    className="vector-2"
                                    alt="Vector"
                                    src="/img/producto2.png"
                                  />
                                </div>
                              </div>
                            </div>

                            <Checkbox
                              boxClassName="checkbox-2"
                              className="checkbox-instance"
                              label="none"
                              variant="not-selected"
                            />
                          </div>
                        </div>

                        <div className="card-violet-dark-3">
                          <div className="text-wrapper-3">View details</div>

                          <div className="text-wrapper-4">
                            Business Checking Account
                          </div>

                          <Checkbox
                            boxClassName="checkbox-2"
                            className="checkbox-3"
                            label="none"
                            variant="not-selected"
                          />
                          <div className="repetitivo">
                            <div className="bank">
                              <div className="overlap-group-3">
                                <img
                                  className="vector-11"
                                  alt="Vector"
                                  src="/img/producto3.png"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-violet-dark-4">
                          <div className="overlap-5">
                            <Checkbox
                              boxClassName="checkbox-2"
                              className="checkbox-4"
                              label="none"
                              variant="not-selected"
                            />
                          </div>

                          <div className="text-wrapper-5">Money Market</div>

                          <div className="text-wrapper-6">View details</div>

                          <div className="transaccion">
                            <div className="group-6">
                              <div className="overlap-group-4">
                                <img
                                  className="vector-23"
                                  alt="Vector"
                                  src="/img/producto4.png"
                                />

                                <div className="group-7" />

                                <div className="group-8" />

                                <div className="group-9" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="group-10">
                          <div className="overlap-6">
                            <div className="card-violet-dark-2">
                              <div className="overlap-4">
                                <div className="group-11">
                                  <div className="overlap-group-5">
                                    <div className="text-wrapper-7">
                                      Veribank
                                    </div>

                                    <div className="text-wrapper-8">
                                      Paquete 2
                                    </div>
                                  </div>

                                  <div className="text-2">{""}</div>
                                </div>

                                <img
                                  className="help-2"
                                  alt="Help"
                                  src="/img/image.svg"
                                />

                                <div className="text-wrapper-9">
                                  Optimiza tu negocio
                                </div>

                                <div className="repetitivo-2">
                                  <div className="group-12">
                                    <div className="overlap-7">
                                      <img
                                        className="group-13"
                                        alt="Group"
                                        src="/img/group-5.png"
                                      />

                                      <img
                                        className="group-14"
                                        alt="Group"
                                        src="/img/group-6.png"
                                      />

                                      <img
                                        className="group-15"
                                        alt="Group"
                                        src="/img/group-7.png"
                                      />

                                      <img
                                        className="group-16"
                                        alt="Group"
                                        src="/img/group-8.png"
                                      />

                                      <img
                                        className="group-17"
                                        alt="Group"
                                        src="/img/group-9.png"
                                      />

                                      <img
                                        className="group-18"
                                        alt="Group"
                                        src="/img/group-10.png"
                                      />

                                      <img
                                        className="group-19"
                                        alt="Group"
                                        src="/img/group-11.png"
                                      />

                                      <img
                                        className="group-20"
                                        alt="Group"
                                        src="/img/group-12.png"
                                      />

                                      <div className="group-21">
                                        <div className="group-22" />
                                      </div>

                                      <div className="group-23">
                                        <div className="vector-wrapper">
                                          <img
                                            className="vector-34"
                                            alt="Vector"
                                            src="/img/vector-33.svg"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="card-violet-dark-5">
                                  <div className="group-24">
                                    <div className="text-wrapper-10">
                                      Saving
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-wrapper-11">View details</div>

                            <Checkbox
                              boxClassName="checkbox-2"
                              className="checkbox-5"
                              label="none"
                              variant="not-selected"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="frame-5">
                        <div className="frame-4" />
                      </div>
                    </div>

                    <div className="frame-6">
                      <div className="text-3">Continue later</div>
                      <div onClick={handleButtonClick}>
                        <ButtonLargeWeb
                          className="button-large-WEB-instance"
                          iconLeft={false}
                          iconRigth={false}
                          primarioActive
                          primarioInactive={false}
                          secundarioActive={false}
                          secundarioInactive={false}
                          terciarioActive={false}
                          terciarioInactive={false}
                          text="Continue"
                          textClassName="button-large-WEB-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="monedas">
                  <div className="overlap-9">
                    <img
                      className="vector-35"
                      alt="Vector"
                      width={50}
                      src="/img/producto1.png"
                    />
                  </div>
                </div>
              </div>

              <div className="group-30">
                <div className="frame-7">
                  © 2025 All rights reserved
                  <img width={100} height="auto" src="/img/veritran.svg" />
                  Innovation Lab
                </div>
              </div>

              <div className="frame-8">
                <div className="frame-9">
                  <div className="text-wrapper-12">
                    Account opening application
                  </div>
                </div>

                <div className="group-31">
                  <div className="group-32">
                    <div className="group-33">
                      <div className="stepper-ingles-largo-wrapper">
                        <StepperInglesLargo
                          className="stepper-ingles-largo-instance"
                          componentsStepsClassName="stepper-ingles-largo-2"
                          componentsStepsClassNameOverride="stepper-ingles-largo-2"
                          numberWrapperClassName="stepper-ingles-largo-2"
                          prendido="three"
                          prendidoHasta={3}
                          property2="three"
                          vector="/img/vector-41-1.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-7">
                {colors.url_logo !== "" && (
                  <img width={30} height="auto" src={colors.url_logo} />
                )}
                <div className="language">
                  <img
                    src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                    height={30}
                    width={30}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
